<template>
  <div class="flex-direction">
    <div class="table-container-v3">
      <table class="table table-v3 is-fullwidth is-striped">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Rol</th>
            <th class="has-text-centered">Cuenta confirmada</th>
            <th class="has-text-centered">Activo</th>
            <th>Fecha Registro</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody v-if="loading">
          <tr v-for="n in 8" :key="n">
            <td><div class="-loading-text -w30"></div></td>
            <td><div class="-loading-text -w80"></div></td>
            <td><div class="-loading-text -w60"></div></td>
            <td><div class="-loading-text -w50"></div></td>
            <td><div class="-loading-text -w40"></div></td>
            <td><div class="-loading-text -w70"></div></td>
            <td><div class="-loading-text -w30"></div></td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="(user, key) in users" :key="key">
            <td>
              {{user.id}}
            </td>
            <td>
              <div class="user-name-cell">
                <span class="user-name-cell__name">
                  {{user.fullName}}
                  <span
                    v-if="user.isCommitteeMember"
                    class="committee-member-tag"
                    :class="{ 'committee-member-tag--inactive': !user.hasVotePermission }"
                  >
                    Miembro comite
                  </span>
                </span>
                <span class="user-name-cell__email">{{ user.email }}</span>
              </div>
            </td>
            <td>
              {{getRoleName(user.role)}}
            </td>
            <td class="has-text-centered">
              {{ user.isConfirmed ? 'Sí' : 'No' }}
            </td>
            <td class="has-text-centered">
              <span class="is-status" :class="user.enabled ? 'is-status-active' : 'is-status-inactive'">
                {{ user.enabled ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td>
              {{formatDate(user.createdAt, 'DD-MMMM-YYYY', systemConfiguration.lang)}}
            </td>
            <td class="has-text-centered">
              <div class="dropdown">
                <a
                  id="panelNavBurger"
                  role="button"
                  data-target="panelNavMenu"
                  aria-expanded="false"
                  aria-label="menu"
                  class="dropbtn"
                >
                  <i class="fas fa-ellipsis-v" />
                </a>
                <div class="dropdown-content">
                  <a class="navbar-item" @click="toggleModalEdit(user)" v-if="canManageUserActions">
                    <i class="show-on-hover fas fa-chevron-right" />
                    Editar
                  </a>
                  <a class="navbar-item" @click="openCommittee(user)" v-if="canManageUserActions && canViewCommitteeAction">
                    <i class="show-on-hover fas fa-chevron-right" />
                    Comité
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  <ModalComponent
      :active="isShowModalEdit"
      :titleModal="'Editar usuario'"
      @hdlOnClick="updateUserLocal"
      @cancel="toggleModalEdit"
      :loader="loadingv2"
      :disabled="loadingv2 || loadingEditDetail"
      widthModal="width: 40%;"
      textSave="Actualizar"
      >
      <div class="has-text-left edit-user-modal">
        <template v-if="loadingEditDetail">
          <div class="field edit-user-modal__row edit-user-modal__row--padded edit-user-modal__row--first">
            <span class="edit-user-modal__skeleton edit-user-modal__skeleton--label"></span>
            <span class="edit-user-modal__skeleton edit-user-modal__skeleton--value"></span>
          </div>
          <div class="field edit-user-modal__row edit-user-modal__row--highlight edit-user-modal__row--spaced">
            <span class="edit-user-modal__skeleton edit-user-modal__skeleton--label"></span>
            <span class="edit-user-modal__skeleton edit-user-modal__skeleton--value"></span>
          </div>
          <div class="field edit-user-modal__row edit-user-modal__row--padded edit-user-modal__row--spaced">
            <span class="edit-user-modal__skeleton edit-user-modal__skeleton--label"></span>
            <span class="edit-user-modal__skeleton edit-user-modal__skeleton--input"></span>
          </div>
          <div class="field edit-user-modal__row edit-user-modal__row--highlight">
            <span class="edit-user-modal__skeleton edit-user-modal__skeleton--label"></span>
            <span class="edit-user-modal__skeleton edit-user-modal__skeleton--switch"></span>
          </div>
        </template>
        <template v-else>
          <div class="field edit-user-modal__row edit-user-modal__row--padded edit-user-modal__row--first">
            <label class="label edit-user-modal__label">Nombre</label>
            <p class="edit-user-modal__text">{{ name || '-' }}</p>
          </div>
          <div class="field edit-user-modal__row edit-user-modal__row--highlight edit-user-modal__row--spaced">
            <label class="label edit-user-modal__label">Correo Electrónico</label>
            <p class="edit-user-modal__text">{{ email || '-' }}</p>
          </div>
          <div class="field edit-user-modal__row edit-user-modal__row--padded edit-user-modal__row--spaced">
            <label class="label edit-user-modal__label">Rol</label>
            <div class="select is-fullwidth edit-user-modal__select" :class="{'is-danger': vverrors.has('roleId')}">
              <select
                class="select edit-user-modal__select-input"
                v-model="roleId"
                name="roleId"
                v-validate="'required'"
              >
                  <option value="" selected disabled> Selecciona un rol </option>
                  <option  v-for="role in roles" :value="role.id" :key="role.id"> {{getRoleName(role)}} </option>
              </select>
            </div>
          </div>
          <div class="field edit-user-modal__row edit-user-modal__row--highlight">
            <label class="label edit-user-modal__label mb-0">Estatus</label>
            <div class="edit-user-modal__switch-wrap">
              <label class="edit-user-switch">
                <input
                  type="checkbox"
                  name="switchExample"
                  @change="changeStatus"
                  :checked="status"
                >
                <span class="edit-user-switch__slider"></span>
              </label>
            </div>
          </div>
        </template>
        <p class="help is-danger edit-user-modal__error">{{error}}</p>
    </div>
  </ModalComponent>
  <ModalCommittee
    :active="isShowModalCommittee"
    :user="committeeUser"
    @saved="handleCommitteeSaved"
    @cancel="closeCommitteeModal"
  />
  <div class="column is-12 has-text-centered">
    <paginator :page="pagination.pageNumber" :pages="pagination.totalPages" :loading="false" :action="getUsers" />
  </div>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '@/mixins/formats'
export default {
  name: 'UsersList',
  mixins: [mixins],
  props: {
    users: {
      type: Array
    },
    pagination: {
      type: Object
    },
    getUsers: {
      type: Function
    },
    roles: {
      type: Array
    },
    role: {
      type: Object
    },
    loading: {
      type: Boolean,
      default: false
    },
    emailUser: {
      type: String
    }
  },
  data () {
    return {
      loadingv2: false,
      loadingEditDetail: false,
      isShowModalEdit: false,
      isShowModalCommittee: false,
      name: '',
      roleId: '',
      email: '',
      status: false,
      userId: '',
      error: '',
      committeeUser: null,
      canViewCommitteeAction: false
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration
    }),
    canManageUserActions () {
      return ['admin', 'manager', 'compliance'].includes(this.role?.code)
    }
  },
  components: {
    Paginator: () => import('@/components/ui/BasePagination.vue'),
    ModalComponent: () => import('@/components/ui/ModalComponent.vue'),
    ModalCommittee: () => import('@/components/Users/ModalCommittee.vue')
  },
  methods: {
    ...mapActions(['updateUser', 'getUserById', 'getServicePermission']),
    async openCommittee (user) {
      this.committeeUser = user || null
      this.isShowModalCommittee = true
    },
    closeCommitteeModal () {
      this.isShowModalCommittee = false
      this.committeeUser = null
    },
    async handleCommitteeSaved () {
      const pageNumber = this.pagination?.pageNumber || 1
      const perPage = this.pagination?.perPage || 10
      await this.getUsers(pageNumber, perPage)
    },
    async loadCommitteeAccessPermission () {
      this.canViewCommitteeAction = false
      try {
        const response = await this.getServicePermission(['getOfferVoterPermission'])
        const enabledCodes = (response || [])
          .filter(service => service?.enabled)
          .map(service => service?.code)
        this.canViewCommitteeAction = enabledCodes.includes('getOfferVoterPermission')
      } catch (_) {
        this.canViewCommitteeAction = false
      }
    },
    async toggleModalEdit (user) {
      if (!user) {
        this.isShowModalEdit = false
        this.loadingEditDetail = false
        this.error = ''
        return
      }

      this.isShowModalEdit = true
      this.loadingEditDetail = true
      this.error = ''
      this.status = user?.enabled || false

      try {
        const detail = await this.getUserById(user?.id)
        const source = detail || user || {}
        const fullName = source?.fullName || [source?.name, source?.lastName].filter(Boolean).join(' ')

        this.name = fullName || user?.fullName || ''
        this.roleId = source?.role?.id || user?.role?.id || ''
        this.email = source?.email || user?.email || ''
        this.userId = user?.id || ''
      } finally {
        this.loadingEditDetail = false
      }
    },
    changeStatus () {
      this.status = !this.status
    },
    async updateUserLocal () {
      if (this.emailUser === this.email) {
        this.error = 'No es posible editar el usuario con sesión activa'
        return
      }
      this.error = ''
      if (await this.$validator.validateAll()) {
        this.loadingv2 = true
        const response = await this.updateUser({
          userId: this.userId,
          role: parseFloat(this.roleId),
          status: this.status
        })
        if (response.success) {
          this.isShowModalEdit = false
          this.getUsers(1, 10)
        }
        this.loadingv2 = false
      }
    }
  },
  mounted () {
    this.loadCommitteeAccessPermission()
  }
}
</script>

<style lang="scss" scoped>
.dropbtn {
  padding: 0 10px;
}

.user-name-cell {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.user-name-cell__name {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  line-height: 1.2;
}

.user-name-cell__email {
  display: inline-block;
  font-size: 12px;
  line-height: 1.1;
  color: #8ea0b3;
}

.committee-member-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 999px;
  background: #efeaff;
  color: #6831ff;
  font-size: 9px;
  font-weight: 600;
  line-height: 1.1;
  white-space: nowrap;
}

.committee-member-tag--inactive {
  background: #eceff3;
  color: #6b6d73;
}

.edit-user-modal {
  padding: 4px 10px 6px;
  margin: 0 auto;

  &__row {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 22px;
  }

  &__row--padded {
    padding: 0 22px;
  }

  &__row--first {
    margin-bottom: 16px;
  }

  &__row--spaced {
    margin: 0 0 16px;
  }

  &__row--highlight {
    margin: 4px 0 16px;
    background: #f3f3f4;
    border-radius: 4px;
    padding: 14px 22px;
  }

  &__label {
    color: #8ea0b3;
    margin-bottom: 0;
    font-weight: 600;
  }

  &__control,
  &__select,
  &__switch-wrap,
  &__text {
    justify-self: end;
    width: 220px;
  }

  &__select-input {
    width: 100%;
    height: 42px;
    border: 1px solid #d3d3d3;
    border-radius: 8px;
    font-size: 13px;
    color: var(--intelligential-color);
    box-shadow: none;
    background: #fff;
  }

  &__text {
    margin: 0;
    min-height: 42px;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: var(--intelligential-color);
    word-break: break-word;
  }

  &__error {
    margin: 0 22px;
  }

  &__skeleton {
    display: inline-block;
    border-radius: 6px;
    background: linear-gradient(90deg, #ececec 25%, #f5f5f5 37%, #ececec 63%);
    background-size: 400% 100%;
    animation: edit-user-skeleton-loading 1.2s ease-in-out infinite;
  }

  &__skeleton--label {
    width: 110px;
    height: 14px;
  }

  &__skeleton--value {
    width: 220px;
    height: 14px;
    justify-self: end;
  }

  &__skeleton--input {
    width: 220px;
    height: 42px;
    justify-self: end;
  }

  &__skeleton--switch {
    width: 53px;
    height: 27px;
    border-radius: 999px;
    justify-self: end;
  }
}

@keyframes edit-user-skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.edit-user-switch {
  position: relative;
  display: inline-block;
  width: 53px;
  height: 27px;
  float: right;
}

.edit-user-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.edit-user-switch__slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #d6d6d8;
  transition: 0.2s;
  border-radius: 999px;
}

.edit-user-switch__slider::before {
  content: '';
  position: absolute;
  height: 17px;
  width: 17px;
  left: 5px;
  top: 5px;
  background-color: #f7f7f7;
  transition: 0.2s;
  border-radius: 50%;
}

.edit-user-switch input:checked + .edit-user-switch__slider {
  background-color: #59c891;
}

.edit-user-switch input:checked + .edit-user-switch__slider::before {
  transform: translateX(23px);
}
</style>
